<template>
  <div class="my-card">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      class="custom-table"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-b-modal.modal-edit-stock
                @click="handleEdit(props.row['id'], props.row['stock'])"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                />
                <span>Edit Stock</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      id="modal-edit-stock"
      v-model="showPaymentModal"
      ok-title="Tambah"
      centered
      size="lg"
      title="Edit Stok"
      @ok="handleSaveEdit()"
    >
      <b-card-body>
        <div class="mt-2">
          <!-- Source Payment -->
          <b-form-group
            label="Total Stok"
            label-for="payment_bank"
            class="w-100"
          >
            <b-form-input
              id="payment_bank"
              v-model="activeStock"
              type="number"
              placeholder="Masukkan Total Stok"
            />
          </b-form-group>
        </div>
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      showPaymentModal: false,
      columns: [
        { field: 'product', label: 'Nama Produk' },
        { field: 'category', label: 'Kategori' },
        { field: 'stock', label: 'Total Stok' },
        { field: 'updated_at', label: 'Terakhir Diperbarui' },
        { field: 'action', label: 'Action' },
      ],
      rows: [],
      searchTerm: '',
      activeId: null,
      activeStock: 0,
      showModal: false,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.getOrderData()
  },
  methods: {
    getOrderData() {
      this.$http.get('/product/list/stock')
        .then(res => {
          console.log(res)
          this.rows = []
          res.data.forEach(so => {
            this.rows.push({
              id: so.id,
              product: so.name || '-', // amanin kalau product null
              category: so.category.name,
              stock: so.stock?.stock || 0,
              updated_at: new Date(so.stock?.updated_at || so.updated_at).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              }),
            })
          })
        })
    },
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    handleEdit(id, stock) {
      this.activeId = id
      this.activeStock = stock

      this.showModal = true
    },
    handleSaveEdit() {
      this.showModal = false

      const payload = {
        stock: this.activeStock,
      }

      this.$http.put(`/stock/update/${this.activeId}`, payload)
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Stok Berhasil Diperbarui!',
            text: 'Mengubah Jumlah Stok telah berhasil dilakukan, dan terekam di sistem',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })

          this.activeId = null
          this.activeStock = 0
          this.getOrderData()
        }).catch(error => {
          const message = error.response?.data?.error || 'Gagal Ubah Stok!'

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';

.custom-table .vgt-table th {
  text-align: center;
  vertical-align: middle;
}

.custom-table .vgt-table td {
  font-size: smaller;
}
</style>
